import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, control } = theme.tokens;

  return {
    chip: {
      appearance: "none",
      border: 0,
      margin: 0,
      font: "inherit",
      cursor: "pointer",
      flex: "none",
      height: control.sm,
      padding: "0 16px",
      borderRadius: radius.pill,
      backgroundColor: color.field,
      color: color.ink,
      fontSize: theme.tokens.fontSize.ui,
      fontWeight: 700,
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      textDecoration: "none",
      whiteSpace: "nowrap",
      boxSizing: "border-box",
      "&:hover": { backgroundColor: color.fieldHover, color: color.ink }
    },
    selected: {
      backgroundColor: color.ink,
      color: color.bg,
      "&:hover": { backgroundColor: color.inkHover, color: color.bg }
    },
    icon: {
      display: "inline-flex",
      "& svg": { fontSize: theme.tokens.iconSize.xs }
    },
    row: {
      display: "flex",
      gap: 8,
      overflowX: "auto",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      // the row's gap does the spacing; ignore any legacy chip margins
      "& > *": { margin: 0 },
      [theme.media.desktop]: { flexWrap: "wrap", overflowX: "visible" }
    }
  };
});

export default withCustomStyles;
